import React from 'react';

import classes from './FlexColumn.module.scss';

const flexColumn = (props) => {
	if(props.dir) {
		return (
			<div dir={props.dir} className={[classes.FlexColumn, props.className].join(' ')}>
				{props.children}
			</div>
		);
	}
	
	return (
		<div className={[classes.FlexColumn, props.className].join(' ')}>
			{props.children}
		</div>
	);
}

export default flexColumn;